// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
// Actions
import { MachineActions, MachineActionTypes } from '../_actions/machine.actions';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { Machine, MachineTechType, MachineType } from '../_models/machine.model';

// tslint:disable-next-line:no-empty-interface
export interface MachineState extends EntityState<Machine> {
    listLoading: boolean;
    actionsloading: boolean;
    totalCount: number;
    lastCreatedMachineId: number;
    lastUpdatedMachineId: number;
    lastDeletedMachineId: number;
    lastQuery: QueryParamsModel;
    showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<Machine> = createEntityAdapter<Machine>();

export const initialMachineState: MachineState = adapter.getInitialState({
    listLoading: false,
    actionsloading: false,
    totalCount: 0,
    lastQuery:  new QueryParamsModel({}),
    lastCreatedMachineId: undefined,
    lastUpdatedMachineId: undefined,
    lastDeletedMachineId: undefined,
    showInitWaitingMessage: true
});

export function machinesReducer(state = initialMachineState, action: MachineActions): MachineState {
    switch  (action.type) {
        case MachineActionTypes.MACHINE_ADDED: return adapter.addOne(action.payload.machine, {
            ...state, lastCreatedMachineId: action.payload.machine.id
        });
        case MachineActionTypes.MACHINE_EDITED: 
            if(action.payload.edited)
                return adapter.updateOne(action.payload.partialMachine, 
                {...state, lastUpdatedMachineId: action.payload.machine.id});
        case MachineActionTypes.MACHINE_PAGE_LOADED: return adapter.addMany(action.payload.machines, {
            ...initialMachineState,
            totalCount: action.payload.totalCount,
            lastQuery: action.payload.page,
            listLoading: false,
            showInitWaitingMessage: false
        });
        case MachineActionTypes.MACHINE_ALL_LOADED: return adapter.addMany(action.payload.machines, {
            ...initialMachineState,
            listLoading: false,
            showInitWaitingMessage: false
        });
        case MachineActionTypes.MACHINE_DELETED: 
            console.dir({reducerMachineDelete: action});
            return adapter.removeOne(action.payload.id, 
                {...state, lastDeletedMachineId: action.payload.id});
        // case UserActionTypes.UsersPageCancelled: return {
        //     ...state, listLoading: false, lastQuery: new QueryParamsModel({})
        // };
        default: return state;
    }
}

export const getMachineState = createFeatureSelector<MachineState>('machines');

export const {
    selectAll,
    selectEntities,
    selectIds,
    selectTotal
} = adapter.getSelectors();

//MACHINE TYPES
export interface MachineTypeState{
    machineTypes:MachineType[],
    machineTypesLoaded:boolean;
}

export const initialMachineTypeState: MachineTypeState = {
    machineTypes: undefined,
    machineTypesLoaded: false
}

export function machineTypesReducer(state = initialMachineTypeState, action: MachineActions):MachineTypeState{
    switch(action.type){
        case MachineActionTypes.MACHINE_TYPES_LOADED:
            return {
                machineTypesLoaded: true,
                machineTypes: action.payload.machineTypes
            };
        default:
            return state;
    }
}

//MACHINE TECH TYPES
export interface MachineTechTypeState{
    machineTechTypes:MachineTechType[],
    machineTechTypesLoaded:boolean;
}

export const initialMachineTechTypeState: MachineTechTypeState = {
    machineTechTypes: undefined,
    machineTechTypesLoaded: false
}

export function machineTechTypesReducer(state = initialMachineTechTypeState, action: MachineActions):MachineTechTypeState{
    switch(action.type){
        case MachineActionTypes.MACHINE_TECH_TYPES_LOADED:
            return {
                machineTechTypesLoaded: true,
                machineTechTypes: action.payload.machineTechTypes
            };
        default:
            return state;
    }
}